/** @jsx jsx */
import { css, jsx } from '@emotion/react';

import * as React from 'react';

import useRouter from 'js/lib/useRouter';

import { useTheme } from '@coursera/cds-core';
import type { Theme } from '@coursera/cds-core';

import ForCreditCollection from 'bundles/enterprise-legacy-learner-home/components/single-program/ForCreditCollection';
import type { Product, ProductType } from 'bundles/enterprise-legacy-learner-home/types/programCommon';
import ProgramMiniModal, {
  closeMiniModalWithRoute,
  useRouterParams,
} from 'bundles/enterprise-legacy-xdp/components/ProgramMiniModal';
import { getProductPath, launchMiniModal } from 'bundles/enterprise-legacy-xdp/hocs/withMiniModal';
import { useEnterpriseProductFeatures } from 'bundles/unified-common/contexts/EnterpriseProductFeaturesContext';
import { useProgramMembership } from 'bundles/unified-common/contexts/EnterpriseProgramContext';

type PropsFromCaller = {
  programId: string;
};

const wrapperStyles = (theme: Theme) =>
  css({
    background: 'var(--cds-color-grey-50)',
  });

export const EnterpriseForCreditCollectionNonConfigurable: React.FC<PropsFromCaller> = ({ programId }) => {
  const router = useRouter();
  const routerParams = useRouterParams(router);
  const programMembership = useProgramMembership();
  const theme = useTheme();
  const { isBrowseOnlyProgram } = useEnterpriseProductFeatures() || {};

  const onProductCardClick = (product: Product, productType: ProductType, collectionId?: string | null) => {
    launchMiniModal(router, product.id, productType === 'course', collectionId || '', undefined, undefined, {
      slug: product.slug,
      productPagePath: getProductPath(product),
    });
  };

  const handleCloseMiniModal = React.useCallback<() => $TSFixMe>(() => {
    closeMiniModalWithRoute(router);
  }, [router]);

  return (
    <div css={wrapperStyles(theme)}>
      <ForCreditCollection
        programId={programId}
        headingLevel={2}
        onProductCardClick={onProductCardClick}
        isSingleProgram
        allowOrgForSpecializationConfiguration
      />
      {routerParams && (
        <ProgramMiniModal
          isProgramMember={programMembership.isProgramMember}
          isProgramAdmin={programMembership.isProgramAdmin}
          programId={programId}
          renderCourseHomeLink
          onCloseMiniModal={handleCloseMiniModal}
          hideAction={isBrowseOnlyProgram}
          disableSponsoredByMessage
          {...routerParams}
        />
      )}
    </div>
  );
};
